import { render, staticRenderFns } from "./DonorInjuriesPrint.vue?vue&type=template&id=57c6d88b"
import script from "./DonorInjuriesPrint.vue?vue&type=script&lang=js"
export * from "./DonorInjuriesPrint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports